module.exports = __webpack_public_path__ + "img/upsanjiao.452388cb.svg";